import { useContext, useEffect, useState } from "react";
import { Pressable, View } from "react-native";
import { useNavigate } from "react-router-dom";
import Text from "../../../../Diathrive/src/components/elements/Text";
import { shopContext } from "../../../../Diathrive/src/contexts/ShopContext";
import { COLORS } from "../../../../Diathrive/src/utils/Constants";
import {
  hasFeatureEnabled,
  WEB_FEATURE_LEVEL,
} from "../../../../Diathrive/src/utils/FeatureConstants";
import { getUserProfileData } from "../../../../Diathrive/src/utils/GeneralStorage";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import { SIDE_PANNEL_TEXT } from "../../utils/Constants";
import styles from "./styles";
import {
  AddIcon,
  CartIcon,
  PlusIcon,
} from "../../../../Diathrive/src/utils/SvgIcons";

export const CartIconButton = ({ navigate, cartProducts }) => (
  <Pressable
    testID={tID("Header-Pressable-Cart")}
    onPress={() => navigate("/store", { state: { openCart: true } })}
    style={styles.cartIcon}
  >
    <CartIcon
      testID={tID("Header-img-Cart")}
      width={20}
      height={20}
      tintColor={COLORS.grey3}
    />
    {cartProducts?.length > 0 && (
      <View testID={tID("Header-View-CartDot")} style={styles.cartStatusDot} />
    )}
  </Pressable>
);

const Header = ({ headerName, setOpenManualEntry = () => {} }) => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState();

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    const profile = await getUserProfileData();
    setProfileData(profile);
  };

  const ShopC = useContext(shopContext);

  return (
    <div
      data-testid={tID("Header-div-Container")}
      style={styles.headerContainer}
    >
      <div data-testid={tID("Header-div-Title")} style={styles.headerTitle}>
        {headerName === SIDE_PANNEL_TEXT.HOME ? (
          <Text
            testID={tID("Header-Text-WelcomeBack")}
            variation="Headline4Regular"
            color={COLORS.grey}
          >
            Welcome back,{" "}
            <Text
              testID={tID("Header-Text-FirstName")}
              variation="Headline4SemiBold"
              color={COLORS.black}
            >
              {` ${profileData?.firstname}`}
            </Text>
          </Text>
        ) : (
          <Text
            testID={tID("Header-Text-Name")}
            variation="Headline4SemiBold"
            color={COLORS.black}
          >
            {headerName}
          </Text>
        )}
      </div>
      <div
        data-testid={tID("Header-div-ActionsContainer")}
        style={styles.headerActions}
      >
        <div
          data-testid={tID("Header-div-ManualInputContainer")}
          style={styles.manualInput}
          onClick={() => setOpenManualEntry(true)}
        >
          <AddIcon testID={tID("Header-img-Plus")} width={16} height={16} />
          <Text
            testID={tID("Header-Text-ManualInput")}
            variation="Text1SemiBold"
            color={COLORS.mainLargeText}
          >
            Manual Input
          </Text>
        </div>
        <CartIconButton
          navigate={navigate}
          cartProducts={ShopC?.cartProducts}
        />
      </div>
    </div>
  );
};

export default Header;
